import { render, staticRenderFns } from "./AgeGenderChart.vue?vue&type=template&id=2f21e2f2&scoped=true"
import script from "./AgeGenderChart.vue?vue&type=script&lang=js"
export * from "./AgeGenderChart.vue?vue&type=script&lang=js"
import style0 from "./AgeGenderChart.vue?vue&type=style&index=0&id=2f21e2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21e2f2",
  null
  
)

export default component.exports